// src/constants/index.js
// Централизованные константы приложения

export const THEMES = {
  DARK: 'dark',
  LIGHT: 'light',
};

export const ROLES = {
  USER: 'user',
  ASSISTANT: 'assistant',
};

export const TABS = {
  DASHBOARD: 'dashboard',
  CHAT: 'chat',
  HISTORY: 'history',
  KNOWLEDGE: 'knowledge',
};

export const LIMITS = {
  MAX_CHATS: 10,
  MAX_MESSAGE_LENGTH: 5000,
  MAX_HISTORY_MESSAGES: 10,
};

export const CATEGORIES = {
  ALL: 'all',
  PYTHON: 'python',
  JAVASCRIPT: 'javascript',
  HTML: 'html',
  CSS: 'css',
  REACT: 'react',
};

export const LANGUAGES = {
  RU: 'ru',
  EN: 'en',
  KY: 'ky',
};
export const LANGUAGE_NAMES = {
  ru: 'Русский',
  en: 'English',
  ky: 'Кыргызча',
};
